'use client';

import { Suspense } from 'react';

import { SnackbarProvider } from '@onyx/ui/components/colleague/snack-bar';
import type { Session } from 'next-auth';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports
import { SessionProvider } from 'next-auth/react';

import { AccessTokenChecker } from '../auth/access-token-checker';
import { StoreProvider } from '../state/store-provider';

export const LayoutProviders = ({
  children,
  session,
}: {
  children: React.ReactNode;
  session: Session | null;
}) => (
  <SessionProvider
    refetchInterval={5 * 60}
    refetchOnWindowFocus
    refetchWhenOffline={false}
    session={session}
  >
    <StoreProvider>
      <Suspense>
        <AccessTokenChecker />
      </Suspense>
      <SnackbarProvider>{children}</SnackbarProvider>
    </StoreProvider>
  </SessionProvider>
);
